import { createFileRoute, redirect } from "@tanstack/react-router";

import {
  isBillingPageEnabled,
  useIsBillingPageEnabled,
} from "@/features/Settings/flag";
import { SettingsPage } from "@/features/Settings/SettingsPage";
import { BillingTab } from "@/features/Settings/tabs/BillingTab";
import { useHasElevatedAccess } from "@/utils/privilegedMode";

export const Route = createFileRoute("/_auth/settings/$siteId/billing")({
  beforeLoad: ({ params }) => {
    if (!isBillingPageEnabled()) {
      throw redirect({
        to: "/dragon-tiles/$siteId",
        params: { siteId: params.siteId },
      });
    }
  },
  component: RouteComponent,
});

function RouteComponent() {
  const { siteId } = Route.useParams();
  const billingEnabled = useIsBillingPageEnabled();
  const isStaff = useHasElevatedAccess();

  return (
    <SettingsPage
      title="Billing"
      description={
        isStaff
          ? "The site's billing plan, payment methods, invoices, and onboarding terms."
          : "The site's payment methods and invoices."
      }
      access={billingEnabled}
      data-testid="settings-billing-page"
    >
      <BillingTab siteId={siteId} />
    </SettingsPage>
  );
}
